import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'text' | 'text-light' | 'quaternary';
export type btnSize = 'sm' | 'md' | 'lg' | 'grid-header';
export type btnShape = 'round' | 'ellipse' | 'regular';

@Component({
  selector: 'eap-button',
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Input() disabled = false;
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() label = 'Button'; // default label
  @Input() width: string = ''; // e.g., '200px', '100%', 'auto'
  @Input() iconSm: string = '';      // icon name
  @Input() icon: string = '';      // icon name
  @Input() size: btnSize  = 'md'; // support small size
  @Input() error: boolean = false;
  @Input() customClass: string | string[] = '';
  @Input() iconPosition: 'start' | 'end' = 'start';
  @Input() tooltip = '';  // show tooltip
  @Input() btnId = '';  // Button id
  @Input() btnShape: btnShape = "regular";

  @Output() clicked = new EventEmitter<void>();

  onClick() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
